import { ContactUsPageComponent } from "../components/HomePageComponents";
import { useEffect } from "react";

const ContactUsPage = () => {
  useEffect(() => {
    document.title = "Contact Us";
  }, []);
  return (
    <div>
      <ContactUsPageComponent />
    </div>
  );
};

export default ContactUsPage;
